'use client';

import {
  OptimizelyProvider as Optimizely,
  createInstance,
} from '@optimizely/react-sdk';
import Script from 'next/script';
import { FC, PropsWithChildren } from 'react';
import { useUser } from 'modules/shop/user/hooks';
import { OPTIMIZELY_PROJECT_ID, OPTIMIZELY_SDK_KEY } from 'src/envVariables';

export const OptimizelyProvider: FC<PropsWithChildren> = ({ children }) => {
  const { user } = useUser();

  if (!OPTIMIZELY_SDK_KEY || !OPTIMIZELY_PROJECT_ID) {
    return children;
  }

  const optimizely = createInstance({
    sdkKey: OPTIMIZELY_SDK_KEY,
  });

  optimizely.setUser({
    id: user?.id?.toString() || 'guest',
  });

  return (
    <>
      <Optimizely optimizely={optimizely}>{children}</Optimizely>
      <Script
        async
        src={`https://cdn.optimizely.com/js/${OPTIMIZELY_PROJECT_ID}.js`}
      />
    </>
  );
};
